var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagenationDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_93_4",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 93 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3517",
    "data-name": "\\uC0AC\\uAC01\\uD615 3517",
    width: 12,
    height: 12,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3301",
    "data-name": "\\uD328\\uC2A4 3301",
    d: "M.961,2.11l3.9,3.88-3.9,3.9.64.639L6.14,5.99,1.6,1.47Zm4.919,0,3.9,3.88-3.9,3.9.64.639,4.521-4.54L6.52,1.47Z",
    fill: "#888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagenationDoubleArrow);
export default __webpack_public_path__ + "static/media/pagenation-double-arrow.581acd84ac3b1b8d6b824152b92cc2eb.svg";
export { ForwardRef as ReactComponent };